// @ts-nocheck
import React, { useContext, useState, useEffect } from 'react'
import {Emit_main} from "../navigation"
import * as C from "../controls"
import * as P from "../program-state"
import {z} from "zod"
import { faBan, faCheck, faFloppyDisk, faRepeat, faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import MqttInitializer, {MqttContext} from "./mqtt/mqtt_initializer"
import * as Billing from "../components/billing"
import { useSearchParams, useNavigate } from "react-router-dom"


const Basic_info_form = () => {
    const { connectStatus, mqttSub, payload } = useContext(MqttContext);

    return (
        <div className="tw-mt-3 tw-grid tw-grid-cols-1 lg:tw-grid-cols-[33%,1fr] tw-gap-3">
            <C.Eres_bare_card>
                <C.Eres_headerlg>Basic Information</C.Eres_headerlg>
                <p className="tw-text-sm">Your name and email address.</p>
            </C.Eres_bare_card>
            <C.Eres_card>
                <div className="tw-m-3">
                    <div className="tw-grid tw-grid-cols-[auto,1fr] tw-gap-3 tw-items-center">
                        <C.Eres_form_label htmlFor="eres-user-email">Email</C.Eres_form_label>
                        <C.Eres_line_edit id="eres-user-email" aria-label="email" defaultValue="demo@eres.io" type="text" disabled/>
                        <C.Eres_form_label htmlFor="eres-user-firstname">First name</C.Eres_form_label>
                        <C.Eres_line_edit id="eres-user-firstname" aria-label="first name" defaultValue="John" type="text"/>
                        <C.Eres_form_label htmlFor="eres-user-lastname">Last name</C.Eres_form_label>
                        <C.Eres_line_edit id="eres-user-lastname" aria-label="last name" defaultValue="" type="text"/>
                    </div>
                    <div className="tw-flex tw-mt-3 tw-justify-end">
                        <C.Eres_iconbutton id="f-save" icon={faFloppyDisk} type="submit">Save</C.Eres_iconbutton>
                    </div>
                </div>
            </C.Eres_card>
        </div>
    )
}


const Password_info_form = () => {
    const [ps, us] = P.use_authenticated_program_state()
    const [current_password, set_current_password] = useState("")
    const [new_password, set_new_password] = useState("")
    const [new_password_confirm, set_new_password_confirm] = useState("")
    const [error_message, set_error_message] = useState("")
    const [success_message, set_success_message] = useState("")

    const handle_password_field_change = (field : string) => (e : R.ChangeEvent<HTMLInputElement>) => {
        const v : string = e.currentTarget.value
        set_error_message("")
        set_success_message("")
        switch (field) {
            case 'current_password':
                set_current_password(v)
                break;
            case 'new_password':
                set_new_password(v)
                break;
            case 'new_password_confirm':
                set_new_password_confirm(v)
                break;
        }
    }

    const change_password = async () => {
        set_error_message("")
        set_success_message("")

        // basic logic before form submission
        if (new_password !== new_password_confirm) {
            set_error_message("New passwords do not match")
            return
        }
        if (!current_password || !new_password) {
            set_error_message("All fields are required")
            return
        }

        const post_url =  P.v1api`auth/change-password/`
        const password_data = {
            current_password,
            new_password,
            new_password_confirm,
        }
        const [ok, resp] = await P.issue_json_post(
            post_url,
            password_data,
            z.any(),
            us.token
        )
        if (ok) {
            set_success_message("Password changed successfully")
            set_current_password("")
            set_new_password("")
            set_new_password_confirm("")
        } else {
            console.error("Password change error:", resp)
            let error_detail = "Failed to change password"

            if (resp instanceof P.http_error) {
                const http_resp = resp.resp
                console.error("HTTP status:", http_resp.status, http_resp.statusText)
                try {
                    const error_body = await http_resp.json()
                    console.error("Error body:", error_body)
                    error_detail = error_body?.detail?.current_password ||
                        error_body?.detail?.new_password ||
                        error_body?.detail?.new_password_confirm ||
                        `HTTP ${http_resp.status}: ${http_resp.statusText}`
                } catch (e) {
                    error_detail = `HTTP ${http_resp.status}: ${http_resp.statusText}`
                }
            }
            set_error_message(error_detail)
        }
    }

    return (
        <div className="tw-mt-3 tw-grid tw-grid-cols-1 lg:tw-grid-cols-[33%,1fr] tw-gap-3">
            <C.Eres_bare_card>
                <C.Eres_headerlg>Password Settings</C.Eres_headerlg>
                <p className="tw-text-sm">You can change your password here.</p>
            </C.Eres_bare_card>
            <C.Eres_card>
                <div className="tw-m-3">
                    <div className="tw-grid tw-grid-cols-[auto,1fr] tw-gap-3 tw-items-center">
                        <C.Eres_form_label htmlFor="eres-yourasset-name">Current password</C.Eres_form_label>
                        <C.Eres_line_edit id="eres-current-password" value={current_password} onChange={handle_password_field_change('current_password')} aria-label="name" type="password"/>
                        <C.Eres_form_label htmlFor="eres-yourasset-weburl">New password</C.Eres_form_label>
                        <C.Eres_line_edit id="eres-new-password" value={new_password} onChange={handle_password_field_change('new_password')} aria-label="url" type="password"/>
                        <C.Eres_form_label htmlFor="eres-yourasset-weburl">Confirm New Password</C.Eres_form_label>
                        <C.Eres_line_edit id="eres-new-password-confirm" value={new_password_confirm} onChange={handle_password_field_change('new_password_confirm')} aria-label="url" type="password"/>
                    </div>
                    {error_message && (
                        <div className="tw-mt-3 tw-p-3 tw-bg-red-50 tw-border tw-border-red-200 tw-rounded tw-text-red-700 tw-text-sm">
                            {error_message}
                        </div>
                    )}
                    {success_message && (
                        <div className="tw-mt-3 tw-p-3 tw-bg-green-50 tw-border tw-border-green-200 tw-rounded tw-text-green-700 tw-text-sm">
                            {success_message}
                        </div>
                    )}
                    <div className="tw-flex tw-mt-3 tw-justify-end">
                        <C.Eres_iconbutton id="f-save" onClick={change_password} icon={faFloppyDisk} type="submit">Update password</C.Eres_iconbutton>
                    </div>
                </div>
            </C.Eres_card>
        </div>
    )
}


const Billing_and_plan = () => {
    const [ps, us] = P.use_authenticated_program_state()
    const [subscription, set_subscription] = useState<P.user_subscription_t | null>(null)
    const [all_plans, set_all_plans] = useState<P.usage_tier_t[]>([])
    const [loading, set_loading] = useState(true)
    const [show_plan_selector, set_show_plan_selector] = useState(false)
    const [show_upgrade_prompt, set_show_upgrade_prompt] = useState(true)
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const [checkout_success, set_checkout_success] = useState(false)

    // check for Stripe checkout success callback
    useEffect(() => {
        const success = searchParams.get('success')
        const session_id = searchParams.get('session_id')
        if (success === 'true' && session_id) {
            const handle_checkout_success = async () => {
                let webhook_processed = false

                const [session_ok, session_data] = await P.fetch_checkout_session_status(session_id, us)

                if (session_ok && session_data.payment_status === 'paid') {
                    set_checkout_success(true)

                    for (let i = 0; i < 5; i++) {
                        await new Promise(resolve => setTimeout(resolve, i === 0 ? 0 : 3000))

                        const [sub_ok, sub_data] = await P.fetch_user_subscription(us)
                        if (sub_ok) {
                            set_subscription(sub_data)
                            if (sub_data.checkout_session_id === session_id) {
                                webhook_processed = true
                                break
                            }
                        }
                    }
                }

                setTimeout(() => {
                    navigate('/account', { replace: true })
                    set_checkout_success(false)
                }, webhook_processed ? 5000 : 20000)
            }

            handle_checkout_success()
        }
    }, [searchParams, navigate, us])

    // poll brands and creatives for usage stats
    P.run_once_on_component_creation(() => {
        void P.poll_connected_brands(ps, us)
        void P.poll_creatives(ps, us)
    })

    useEffect(() => {
        const load_data = async () => {
            const [sub_ok, sub_data] = await P.fetch_user_subscription(us)
            const [plans_ok, plans_data] = await P.fetch_all_plans(us)

            if (sub_ok) set_subscription(sub_data)
            if (plans_ok) set_all_plans(plans_data)

            set_loading(false)
        }
        load_data()
    }, [us])

    const handle_manage_billing = async () => {
        console.log("handle_manage_billing: calling customer portal API")
        const [ok, data] = await P.get_customer_portal(us)
        console.log("handle_manage_billing: response", { ok, data })
        if (ok) {
            console.log("handle_manage_billing: redirecting to", data.url)
            window.location.href = data.url
        } else {
            alert("Failed to open billing portal. Please try again.")
        }
    }

    const handle_subscribe = async (plan : P.usage_tier_t) => {
        const [ok, resp] = await P.create_checkout_session(us, plan.stripe_price_id)
        if (ok) {
            window.location.href = resp.uri
        } else {
            alert("Failed to create checkout session. Please try again.")
        }
    }

    const format_price = (price : number, duration : number) => {
        const period = duration === 1 ? "month" : duration === 12 ? "year" : `${duration} months`
        return `$${price.toFixed(2)} / ${period}`
    }

    const format_renewal_date = (end_date : string) => {
        return new Date(end_date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })
    }

    if (loading) {
        return (
            <div className="tw-mt-3 tw-grid tw-grid-cols-1 lg:tw-grid-cols-[33%,1fr] tw-gap-3">
                <C.Eres_bare_card>
                    <C.Eres_headerlg>Billing and Plan Settings</C.Eres_headerlg>
                    <p className="tw-text-sm">Manage your plan and billing information here</p>
                </C.Eres_bare_card>
                <C.Eres_card>
                    <div className="tw-m-3 tw-text-center tw-py-8">
                        Loading subscription data...
                    </div>
                </C.Eres_card>
            </div>
        )
    }

    const plan = subscription?.plan
    // user has a subscription if they have a plan (subscription.subscription can be null for some backend states)
    const has_subscription = !!plan

    // new user flow - only show if no plan at all
    if (!has_subscription) {
        return (
            <>
                <div className="tw-mt-3 tw-grid tw-grid-cols-1 lg:tw-grid-cols-[33%,1fr] tw-gap-3">
                    <C.Eres_bare_card>
                        <C.Eres_headerlg>Billing and Plan Settings</C.Eres_headerlg>
                        <p className="tw-text-sm">Choose a plan to get started with Eres</p>
                    </C.Eres_bare_card>
                    <div>
                        <Billing.New_user_plan_selector
                            plans={all_plans}
                            on_select={handle_subscribe}
                        />
                    </div>
                </div>
            </>
        )
    }

    // existing user flow
    const usage = P.get_usage_stats(us)
    const is_free_tier = plan.id === 1

    // check if user is at or near limits
    const brand_percent = plan.brand_limit ? (usage.brand_count / plan.brand_limit) * 100 : 0
    const campaign_percent = plan.campaign_limit ? (usage.campaign_count / plan.campaign_limit) * 100 : 0
    const needs_upgrade = brand_percent >= 80 || campaign_percent >= 80
    const at_limit = brand_percent >= 100 || campaign_percent >= 100

    let upgrade_message = ""
    let tier_suggestion = ""
    if (brand_percent >= 100) {
        upgrade_message = `You've reached your brand limit (${usage.brand_count}/${plan.brand_limit}). Create more brands by upgrading.`
        tier_suggestion = "Growth"
    } else if (campaign_percent >= 100) {
        upgrade_message = `You've reached your campaign limit (${usage.campaign_count}/${plan.campaign_limit}). Create more campaigns by upgrading.`
        tier_suggestion = "Growth"
    } else if (brand_percent >= 80) {
        upgrade_message = `You're using ${usage.brand_count} of ${plan.brand_limit} brands (${Math.round(brand_percent)}%). Consider upgrading soon.`
        tier_suggestion = "Growth"
    } else if (campaign_percent >= 80) {
        upgrade_message = `You're using ${usage.campaign_count} of ${plan.campaign_limit} campaigns (${Math.round(campaign_percent)}%). Consider upgrading soon.`
        tier_suggestion = "Growth"
    }

    return (
        <>
            {/* success banner */}
            {checkout_success && (
                <div className="tw-mt-3 tw-bg-green-50 tw-border tw-border-green-200 tw-rounded-lg tw-p-4">
                    <div className="tw-flex tw-items-center tw-gap-2">
                        <FontAwesomeIcon icon={faCheck} className="tw-text-green-600" />
                        <div>
                            <p className="tw-font-semibold tw-text-green-800">Subscription successful!</p>
                            <p className="tw-text-sm tw-text-green-700">Your plan has been activated. Refreshing subscription details...</p>
                        </div>
                    </div>
                </div>
            )}

            {/* current plan overview */}
            <div className="tw-mt-3 tw-grid tw-grid-cols-1 lg:tw-grid-cols-[33%,1fr] tw-gap-3">
                <C.Eres_bare_card>
                    <C.Eres_headerlg>Current Plan</C.Eres_headerlg>
                    <p className="tw-text-sm">Your subscription details and limits</p>
                </C.Eres_bare_card>
                <C.Eres_card>
                    <div className="tw-m-3">
                        <div className="tw-flex tw-items-center tw-justify-between tw-mb-2">
                            <C.Eres_headerlg>{plan.name.replace(' (Annual)', '')}</C.Eres_headerlg>
                            <C.Eres_iconbutton
                                id="f-change"
                                icon={show_plan_selector ? faChevronUp : faChevronDown}
                                onClick={() => set_show_plan_selector(!show_plan_selector)}
                            >
                                {show_plan_selector ? 'Hide Plans' : 'Compare Plans'}
                            </C.Eres_iconbutton>
                        </div>
                        <C.Eres_header2xl>{format_price(plan.price, plan.eligibility_duration)}</C.Eres_header2xl>
                        {subscription.subscription?.end_date && (
                            <p className="tw-text-sm tw-text-gray-600 tw-mt-1">
                                Renews on {format_renewal_date(subscription.subscription.end_date)}
                            </p>
                        )}
                    </div>
                </C.Eres_card>
            </div>

            {/* usage dashboard */}
            <div className="tw-mt-3 tw-grid tw-grid-cols-1 lg:tw-grid-cols-[33%,1fr] tw-gap-3">
                <C.Eres_bare_card>
                    <C.Eres_headerlg>Usage</C.Eres_headerlg>
                    <p className="tw-text-sm">Track your resource usage</p>
                </C.Eres_bare_card>
                <C.Eres_card>
                    <div className="tw-m-3 tw-space-y-4">
                        <Billing.Usage_progress_bar
                            label="Brands"
                            current={usage.brand_count}
                            limit={plan.brand_limit}
                        />
                        <Billing.Usage_progress_bar
                            label="Campaigns"
                            current={usage.campaign_count}
                            limit={plan.campaign_limit}
                        />
                        <Billing.Usage_progress_bar
                            label="Team Members"
                            current={usage.team_member_count}
                            limit={plan.team_seats}
                        />
                    </div>
                </C.Eres_card>
            </div>

            {/* upgrade prompt */}
            {needs_upgrade && show_upgrade_prompt && (
                <div className="tw-mt-3 tw-grid tw-grid-cols-1 lg:tw-grid-cols-[33%,1fr] tw-gap-3">
                    <C.Eres_bare_card />
                    <div>
                        <Billing.Upgrade_prompt_banner
                            message={upgrade_message}
                            tier_suggestion={tier_suggestion}
                            on_upgrade={() => set_show_plan_selector(true)}
                            on_dismiss={() => set_show_upgrade_prompt(false)}
                        />
                    </div>
                </div>
            )}

            {/* plan comparison */}
            {show_plan_selector && (
                <div className="tw-mt-3 tw-grid tw-grid-cols-1 lg:tw-grid-cols-[33%,1fr] tw-gap-3">
                    <C.Eres_bare_card>
                        <C.Eres_headerlg>Compare Plans</C.Eres_headerlg>
                        <p className="tw-text-sm">Upgrade or change your plan</p>
                    </C.Eres_bare_card>
                    <C.Eres_card>
                        <div className="tw-m-3">
                            <Billing.Plan_comparison_inline
                                plans={all_plans}
                                current_plan_id={plan.id}
                                on_select={handle_subscribe}
                            />
                        </div>
                    </C.Eres_card>
                </div>
            )}

            {/* billing management */}
            {!is_free_tier && (
                <div className="tw-mt-3 tw-grid tw-grid-cols-1 lg:tw-grid-cols-[33%,1fr] tw-gap-3">
                    <C.Eres_bare_card>
                        <C.Eres_headerlg>Billing Management</C.Eres_headerlg>
                        <p className="tw-text-sm">Payment methods and invoices</p>
                    </C.Eres_bare_card>
                    <C.Eres_card>
                        <div className="tw-m-3">
                            <p className="tw-text-sm tw-mb-3">
                                Manage your payment method, billing information, and download invoices
                            </p>
                            <div className="tw-flex tw-flex-col sm:tw-flex-row tw-gap-2">
                                <C.Eres_button onClick={handle_manage_billing}>
                                    Manage Payment & Billing
                                </C.Eres_button>
                                <button
                                    className="tw-px-4 tw-py-2 tw-bg-white tw-text-red-600 tw-border tw-border-red-300 tw-rounded tw-font-medium tw-flex tw-items-center tw-justify-center tw-gap-2 hover:tw-bg-red-50 tw-whitespace-nowrap"
                                    onClick={handle_manage_billing}
                                >
                                    <FontAwesomeIcon icon={faBan} />
                                    Cancel Plan
                                </button>
                            </div>
                        </div>
                    </C.Eres_card>
                </div>
            )}
        </>
    )
}


const Account_info_form = () => {
    return (
        <>
            <Basic_info_form />
            <Password_info_form />
            <Billing_and_plan />
        </>
    )
}

export default function Account_info() {
    return (
        <Emit_main page_id="PAGE-account">
            <MqttInitializer>
                <Account_info_form />
            </MqttInitializer>
        </Emit_main>
    )
}
